var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n        "+_vm._s(_vm.desc || _vm.$t('k_335866'))+"\n    ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-content"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("./images/empty.png")}})])
}]

export { render, staticRenderFns }